import { Component } from 'react';

// SVG Icons as Components
export default function WhatsAppIcon({ size = 28, className = '', title = 'WhatsApp', ariaHidden = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : title}
    >
      {!ariaHidden && <title>{title}</title>}
      <circle cx="12" cy="12" r="10" fill="#25D366" />
      <path
        fill="#fff"
        d="M17.472 14.382c-.297-.149-1.758-.866-2.03-.967-.273-.099-.472-.148-.672.149-.199.297-.771.966-.945 1.164-.174.199-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.885-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.199-.298.299-.497.099-.199.05-.373-.025-.522-.074-.148-.672-1.621-.922-2.223-.244-.583-.493-.504-.672-.514l-.572-.01c-.199 0-.522.074-.797.373s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.199 2.096 3.2 5.076 4.487.709.306 1.262.489 1.695.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.007-1.413.248-.694.248-1.289.174-1.413-.074-.124-.272-.199-.57-.347z"
      />
    </svg>
  );
}

export function LinkedInIcon({ size = 28, className = '', title = 'LinkedIn', ariaHidden = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : title}
    >
      {!ariaHidden && <title>{title}</title>}

      <path
        d="M8.34 9.5H5.67V18h2.67V9.5zM7 5.5a1.55 1.55 0 1 0 0 3.1 1.55 1.55 0 0 0 0-3.1zM18.34 18v-4.66c0-2.49-1.33-3.65-3.1-3.65-1.43 0-2.07.79-2.43 1.34V9.5h-2.67V18h2.67v-4.5c0-.24.02-.48.09-.65.19-.48.63-.97 1.36-.97.96 0 1.34.73 1.34 1.8V18h2.67z"
      />
    </svg>
  );
}

export function TikTokIcon({ size = 28, className = '', title = 'TikTok', ariaHidden = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      fill="none"
      stroke="currentColor"
      strokeWidth="0.5"
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : title}
    >
      {!ariaHidden && <title>{title}</title>}

      {/* cyan offset */}
      <path
        d="M16.6 8.05a4.78 4.78 0 0 1-1.06-.7v4.95a3.95 3.95 0 1 1-3.95-3.95c.13 0 .26.01.39.02v1.97a2 2 0 1 0 1.6 1.96V5h1.96a2.82 2.82 0 0 0 1.06 1.94z"
      />
      {/* pink offset */}
      <path

        d="M17.6 8.6a4.8 4.8 0 0 1-1.06-.55v4.95a3.95 3.95 0 1 1-3.95-3.95c.13 0 .26.01.39.02v1.97a2 2 0 1 0 1.6 1.96V5.5h1.96A2.82 2.82 0 0 0 17.6 7.5z"
      />
      {/* white note */}
      <path

        d="M17.1 8.3a4.8 4.8 0 0 1-1.06-.6v4.95a3.95 3.95 0 1 1-3.95-3.95c.13 0 .26.01.39.02v1.97a2 2 0 1 0 1.6 1.96V5.25h1.96A2.82 2.82 0 0 0 17.1 7.2z"
      />
    </svg>
  );
}

export const FacebookIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
  </svg>
);

export const TwitterIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
  </svg>
);

export const XIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
  </svg>
);

export const InstagramIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </svg>
);
// ── OMR SYMBOL ───────────────────────────────────────────────────────────────
export class OMR extends Component {
  render() {
    const { size = 16, className = '', color = '#000', style: extraStyle = {} } = this.props;
    const w = size * (729.6 / 365.93);
    return (
      <svg
        className={`omr-sign ${className}`}
        width={w}
        height={size}
        viewBox="0 0 729.6 365.93"
        style={{
          fill: color,
          flexShrink: 0,
          verticalAlign: 'middle',
          display: 'inline-block',
          ...extraStyle,
        }}
      >
        <path d="M241.67,213.77c-.63-49.2,11.44-95.41,35.76-137.75C313.47,13.28,353.02-6.48,421.55,28.87c10.67,5.5,53.6,35.43,57.81,44.54,5.03,10.87-27.48,103.87-29.11,122.3-34.69-37.51-99.37-98.66-154.85-69.62-45.05,23.58-12.02,62.54,11.46,87.68h409.36l-26.41,47.64h-332.5c-.31,1.8.87,3.3,2.53,4.6,12.44,9.72,80.97,39.54,94.75,39.54h210.71l-26.89,48.94H13.37l26.91-48.94h253.38l-37.11-44.13H64.75l26.41-47.64h150.51Z" />
      </svg>
    );
  }
}

// ── STATUS PILL ───────────────────────────────────────────────────────────────
export class StatusPill extends Component {
  render() {
    const { status } = this.props;
    const map = {
      verified: { bg: 'rgba(27,143,155,0.12)', color: '#1b8f9b' },
      pending: { bg: 'rgba(196,127,23,0.12)', color: '#c47f17' },
      refunded: { bg: 'rgba(189,196,50,0.15)', color: '#7a8a00' },
      hold: { bg: 'rgba(224,82,82,0.12)', color: '#e05252' },
    };
    const s = map[status] || map.pending;
    return (
      <span className="status-pill" style={{ background: s.bg, color: s.color }}>
        {status}
      </span>
    );
  }
}


export const OmrRiyal = ({
  width = 24,
  height = 24,
  color = 'currentColor',
  className = '',
  style = {},
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 729.6 365.93"
    width={width}
    height={height}
    fill={color}
    className={className}
    style={style}
  >
    <g id="RHhDp6">
      <path d="M241.67,213.77c-.63-49.2,11.44-95.41,35.76-137.75C313.47,13.28,353.02-6.48,421.55,28.87c10.67,5.5,53.6,35.43,57.81,44.54,5.03,10.87-27.48,103.87-29.11,122.3-34.69-37.51-99.37-98.66-154.85-69.62-45.05,23.58-12.02,62.54,11.46,87.68h409.36l-26.41,47.64h-332.5c-.31,1.8.87,3.3,2.53,4.6,12.44,9.72,80.97,39.54,94.75,39.54h210.71l-26.89,48.94H13.37l26.91-48.94h253.38l-37.11-44.13H64.75l26.41-47.64h150.51Z" />
    </g>
  </svg>
);

export const SAR = ({
  width = 24,
  height = 24,
  size = 24,
  color = 'currentColor',
  className = '',
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    width={width || size}
    height={height || size}
    fill={color}
    className={className}
    style={style}
  >
    <path
      d="m6.836 8.468 2.595-.55q-.045.454-.236.876l-2.589.55q.04-.46.23-.876Zm2.359-1.325-2.589.55v-1.65l-.808.173v.916q0 .123-.068.224l-.421.623q-.168.242-.45.298l-2.29.489q.045-.455.236-.876l2.184-.466v-1.04l-2.038.433q.045-.455.235-.87l1.803-.388V2.353q.342-.416.809-.68v3.718l.808-.174v-2.46q.343-.415.803-.68v2.971l2.022-.432q-.045.455-.236.876l-1.786.382v.82l2.022-.427q-.045.46-.236.876Z"
      aria-label="⃁"
    />
  </svg>
);

export const SaudiRiyalLogo = ({
  width = 24,
  height = 24,
  size = 24,
  color = 'currentColor',
  className = '',
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    width={width || size}
    height={height || size}
    fill={color}
    className={className}
    style={style}
  >
    <path
      d="m6.836 8.468 2.595-.55q-.045.454-.236.876l-2.589.55q.04-.46.23-.876Zm2.359-1.325-2.589.55v-1.65l-.808.173v.916q0 .123-.068.224l-.421.623q-.168.242-.45.298l-2.29.489q.045-.455.236-.876l2.184-.466v-1.04l-2.038.433q.045-.455.235-.87l1.803-.388V2.353q.342-.416.809-.68v3.718l.808-.174v-2.46q.343-.415.803-.68v2.971l2.022-.432q-.045.455-.236.876l-1.786.382v.82l2.022-.427q-.045.46-.236.876Z"
      aria-label="⃁"
    />
  </svg>
);


export const AuctionIcon = ({
  width = 24,
  height = 24,
  color = 'currentColor',
  className = '',
  style = {},
}) => {
  return (
    <svg
      viewBox="0 0 43 41"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      className={className}
      style={style}
    >
      <g>
        <path d="M38.7484 30.9084L22.0119 19.9389L19.3956 23.8389C20.4808 24.6932 20.7109 26.114 20.0147 27.1949C19.3185 28.2758 17.8752 28.6805 16.6643 28.0244L6.16959 21.1838C5.02038 20.3861 4.75116 18.891 5.48528 17.7665C6.2194 16.6419 7.74101 16.2914 8.98036 17.0396L17.4542 4.62807C16.235 3.84453 15.9148 2.33764 16.624 1.19183C17.332 0.0507492 18.8062 -0.35164 20.0301 0.344576L30.4726 7.14861C31.6385 7.93568 31.9302 9.44612 31.1925 10.5837C30.4549 11.7212 28.9783 12.0422 27.752 11.3589L25.0764 15.3746L41.6979 26.2709C43.0037 27.1064 43.3773 28.7596 42.585 30.0423C41.8118 31.2943 40.0992 31.7958 38.7472 30.9096L38.7484 30.9084ZM29.7587 8.14573L19.4561 1.43374C18.8287 1.02545 18.0507 1.25438 17.689 1.82787C17.3498 2.36832 17.4435 3.1436 18.0472 3.53655L28.3877 10.2804C29.021 10.6934 29.8073 10.4751 30.1643 9.89925C30.5213 9.32339 30.4122 8.57054 29.7587 8.14455V8.14573ZM18.3662 23.1616L26.7356 10.6733L18.4848 5.29714L10.0027 17.7216L18.3662 23.1616ZM39.4292 29.8912C40.2024 30.3987 41.1263 30.0824 41.5426 29.4263C41.9873 28.7266 41.8118 27.8097 41.0765 27.3282L24.3886 16.3882L22.6962 18.9229L39.4292 29.8924V29.8912ZM18.5607 24.7676L8.25691 18.052C7.62716 17.6414 6.8539 17.868 6.49455 18.4214C6.1352 18.9748 6.24193 19.7631 6.8456 20.156L17.2312 26.927C17.8491 27.3306 18.6307 27.0875 18.9829 26.5223C19.3351 25.957 19.2213 25.1971 18.5607 24.7664V24.7676Z" fill={color} />
        <path d="M23.3863 40.9966L0.657058 41.0001C0.251454 41.0001 0.011886 40.7299 0.00951406 40.3735L2.62377e-05 38.161C-0.00590365 36.7662 0.993876 35.6369 2.42417 35.5968C2.45856 35.133 2.43484 34.7235 2.43602 34.2704C2.44077 32.8886 3.49392 31.7959 4.90879 31.7959L19.0065 31.7888C20.4178 31.7888 21.5018 32.7883 21.5516 34.1902C21.5682 34.6598 21.5101 35.1118 21.5825 35.5968C22.925 35.6487 23.971 36.6706 23.971 37.9804V40.3782C23.971 40.6461 23.7979 40.9966 23.3863 40.9966ZM20.3087 35.5968C20.3312 35.0433 20.3277 34.6586 20.3158 34.2185C20.2992 33.5553 19.807 33.0219 19.0978 33.0219H4.90997C4.17585 33.0208 3.67063 33.5718 3.67063 34.2728C3.67063 34.7176 3.64809 35.1342 3.68723 35.5991L20.3075 35.5968H20.3087ZM22.7328 39.7764L22.7495 38.0854C22.7376 37.2122 22.1256 36.8252 21.3109 36.8252L2.60681 36.8275C1.82169 36.8275 1.23226 37.2594 1.23819 38.0819C1.24175 38.62 1.20854 39.1864 1.26072 39.7776L22.734 39.7752L22.7328 39.7764Z" fill={color} />
      </g>
      <defs>
        <clipPath >
          <rect width="43" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BuildingIcon = ({
  width = 24,
  height = 24,
  color = 'currentColor',
  className = '',
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 35"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g>
        <path d="M34.9988 34.1965C34.9988 34.6792 34.6852 34.9987 34.234 34.9987H0.76713C0.322941 34.9987 0.00349755 34.6687 0.00349755 34.235L0 10.2716C0.0116585 9.88222 0.258819 9.4998 0.668032 9.49863L8.16329 9.47998L8.16562 0.746008C8.16562 0.473181 8.31018 0.259816 8.4769 0.145555C8.66227 0.0196346 8.88495 -0.051487 9.15892 0.0406213L26.2643 5.76999C26.6572 5.90408 26.8402 6.18157 26.839 6.59547L26.8367 17.1051L34.234 17.1133C34.6701 17.1133 34.9732 17.413 35 17.8618L34.9977 34.1953L34.9988 34.1965ZM25.3503 33.4969V7.0292L9.65441 1.77552L9.65208 33.5133L25.3491 33.4969H25.3503ZM8.16212 33.5133V10.9677L1.48879 10.9794V33.5098L8.16212 33.5144V33.5133ZM33.5147 33.4969L33.5112 18.6022L26.8449 18.594L26.8367 33.5109L33.5159 33.4958L33.5147 33.4969Z" fill={color} />
        <path d="M15.6189 18.5977H13.2277C12.7928 18.5954 12.4815 18.2689 12.4664 17.883C12.4512 17.4971 12.7392 17.1554 13.1694 17.1123L15.5454 17.1146C15.9698 17.1146 16.2729 17.4213 16.2974 17.8002C16.3219 18.1791 16.0817 18.5312 15.6177 18.5977H15.6189Z" fill={color} />
        <path d="M21.8142 18.5895L19.4231 18.5918C18.9929 18.5918 18.7131 18.2397 18.7002 17.8887C18.6851 17.4632 18.9987 17.1146 19.4534 17.1157L21.8305 17.1204C22.2328 17.1204 22.5102 17.462 22.5312 17.8095C22.5545 18.1837 22.2841 18.5883 21.8142 18.5895Z" fill={color} />
        <path d="M15.6003 22.3334L13.2266 22.3427C12.7964 22.3438 12.4852 22.0127 12.4677 21.6361C12.4479 21.2222 12.7673 20.8596 13.2255 20.8596H15.563C15.9874 20.862 16.28 21.1884 16.2987 21.558C16.3173 21.9276 16.062 22.3322 15.6003 22.3334Z" fill={color} />
        <path d="M21.8166 22.3357L19.4383 22.3403C19.0139 22.3403 18.7189 22.0034 18.7015 21.6431C18.6805 21.2316 18.9859 20.8631 19.4371 20.8619L21.7758 20.8596C22.206 20.8596 22.5138 21.1779 22.5324 21.5638C22.5499 21.9299 22.2841 22.3345 21.8166 22.3357Z" fill={color} />
        <path d="M15.584 26.0784H13.1696C12.7382 26.0784 12.4526 25.6937 12.4666 25.3182C12.4805 24.9428 12.7918 24.6035 13.2279 24.6035L15.577 24.6082C16.0049 24.6082 16.287 24.9568 16.2987 25.3124C16.3115 25.696 16.0457 26.0784 15.5829 26.0784H15.584Z" fill={color} />
        <path d="M21.8679 26.0712L19.4545 26.084C18.9964 26.0864 18.6851 25.7273 18.7002 25.3122C18.7154 24.8971 19.0453 24.5986 19.5058 24.5986L21.7723 24.6033C22.1815 24.6033 22.4799 24.8889 22.5266 25.2481C22.5732 25.6072 22.3307 26.0689 21.8667 26.0712H21.8679Z" fill={color} />
        <path d="M15.6177 14.8376L13.2289 14.8492C12.7859 14.8516 12.4722 14.5053 12.4676 14.1252C12.4629 13.716 12.7719 13.3697 13.2207 13.3709L15.5827 13.3755C15.9919 13.3755 16.2671 13.6926 16.2986 14.0494C16.33 14.4062 16.0852 14.8353 15.6177 14.8376Z" fill={color} />
        <path d="M21.7407 13.3674C22.235 13.3674 22.5358 13.7125 22.5323 14.1264C22.5288 14.5088 22.2141 14.8504 21.7722 14.8504L19.423 14.8469C18.987 14.8469 18.7025 14.482 18.699 14.1346C18.6944 13.6752 19.0348 13.3662 19.5046 13.3662H21.7407V13.3674Z" fill={color} />
        <path d="M15.5431 29.828H13.2207C12.7707 29.8303 12.4618 29.4864 12.4676 29.0737C12.4723 28.6936 12.7871 28.3496 13.2289 28.3496L15.5781 28.3543C16.0118 28.3543 16.2928 28.7122 16.2998 29.0643C16.3079 29.4701 16.0293 29.8268 15.5431 29.8268V29.828Z" fill={color} />
        <path d="M21.8295 29.8222L19.5059 29.8339C19.0606 29.8362 18.7365 29.5657 18.7015 29.153C18.6689 28.7636 18.9545 28.3567 19.422 28.3555L21.7712 28.3508C22.1827 28.3508 22.487 28.647 22.5267 29.0026C22.5698 29.3873 22.3133 29.8187 21.8283 29.8211L21.8295 29.8222Z" fill={color} />
        <path d="M15.5768 11.0984L13.2288 11.1031C12.7858 11.1031 12.4698 10.765 12.4663 10.3732C12.4628 9.98148 12.7718 9.62237 13.2206 9.62354L15.5815 9.6282C16.0199 9.6282 16.3055 9.98614 16.3008 10.3802C16.2962 10.7428 16.0105 11.0973 15.5768 11.0984Z" fill={color} />
        <path d="M21.8119 11.0961L19.4231 11.0984C18.9882 11.0984 18.7049 10.7405 18.6991 10.3802C18.6932 9.98497 18.98 9.6282 19.4184 9.6282L21.7792 9.62354C22.2013 9.62354 22.4986 9.92784 22.5312 10.3033C22.5639 10.6787 22.2887 11.0961 21.813 11.0973L21.8119 11.0961Z" fill={color} />
        <path d="M6.30966 21.5592C6.3598 22.5642 5.03772 22.3602 4.07823 22.3403C3.65386 22.331 3.36006 22.0069 3.34257 21.6431C3.32159 21.2292 3.62588 20.8631 4.07706 20.8619L5.5402 20.8596C5.9774 20.8596 6.28984 21.1733 6.30966 21.5592Z" fill={color} />
        <path d="M6.3096 17.806C6.37023 18.818 5.02717 18.6128 4.06301 18.5918C3.63398 18.5825 3.35417 18.2421 3.34135 17.8888C3.32619 17.4609 3.63864 17.1158 4.09332 17.1169L5.59727 17.1204C6.00648 17.1204 6.28745 17.4527 6.30844 17.8072L6.3096 17.806Z" fill={color} />
        <path d="M5.63562 26.0726C5.09699 26.1099 4.59568 26.0819 4.09436 26.0831C3.66533 26.0831 3.3692 25.7648 3.34588 25.3987C3.31907 24.9813 3.62219 24.6082 4.07687 24.607L5.54002 24.6035C5.95389 24.6035 6.25818 24.8868 6.30598 25.2343C6.35961 25.6295 6.11012 26.0411 5.63678 26.0738L5.63562 26.0726Z" fill={color} />
        <path d="M5.59493 29.8244L4.14694 29.8326C3.6736 29.8349 3.33784 29.5166 3.34483 29.0689C3.35066 28.6748 3.67943 28.3448 4.14694 28.3472L5.61474 28.3577C6.03212 28.36 6.30493 28.7144 6.31309 29.0666C6.32242 29.4478 6.0636 29.8221 5.59493 29.8244Z" fill={color} />
        <path d="M5.57964 14.8459H4.06287C3.62801 14.8459 3.34704 14.481 3.34121 14.1347C3.33305 13.6765 3.67581 13.3675 4.14564 13.3687L5.547 13.3722C5.97603 13.3722 6.27799 13.6648 6.3083 14.0601C6.33861 14.4553 6.06347 14.8471 5.57964 14.8482V14.8459Z" fill={color} />
        <path d="M31.6576 21.5568C31.7066 22.577 30.409 22.3415 29.4611 22.3426C29.0239 22.3426 28.7092 22.0197 28.6905 21.6396C28.6684 21.2152 28.996 20.8572 29.4588 20.8584L30.9243 20.8607C31.3487 20.8607 31.6413 21.1872 31.6588 21.5568H31.6576Z" fill={color} />
        <path d="M31.6552 25.3123C31.689 26.2999 30.4077 26.1098 29.4016 26.0795C28.9621 26.0655 28.6706 25.7053 28.6869 25.3123C28.7033 24.9194 29.018 24.6011 29.4611 24.6023L30.923 24.6058C31.3497 24.6058 31.6424 24.9393 31.6552 25.3123Z" fill={color} />
        <path d="M30.9032 29.8279L29.4541 29.8303C29.0239 29.8303 28.7173 29.5353 28.6881 29.1494C28.659 28.7634 28.9365 28.36 29.3853 28.3577L30.8531 28.3472C31.2856 28.3437 31.6063 28.6317 31.6482 28.9826C31.7007 29.4234 31.4174 29.8279 30.9032 29.8279Z" fill={color} />
      </g>
      <defs>
        <clipPath>
          <rect width="35" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AuctionHammer = ({
}) => {
  return (
    <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_431_119)">
        <path d="M28.7198 31.3263C27.5926 30.2004 27.5883 28.5166 28.6518 27.361L25.7544 24.4776L6.35715 43.8569C4.85035 45.3623 2.42446 45.191 1.0437 43.7379C-0.397958 42.2198 -0.346976 39.859 1.20373 38.3861L20.4268 19.1611L17.5349 16.2593C16.3482 17.347 14.6615 17.2861 13.5909 16.1928L12.0473 14.6562C10.9441 13.5586 10.8492 11.8125 11.9751 10.6837L21.758 0.883615C22.9206 -0.28192 24.6866 -0.305995 25.8379 0.876535L27.4679 2.52216C28.5145 3.57865 28.4635 5.24411 27.4269 6.36857L38.5395 17.4759C39.7333 16.3797 41.403 16.4477 42.475 17.5198L44.1178 19.1611C45.1771 20.2856 45.1785 21.9822 44.0682 23.0925L34.2783 32.8856C33.1468 34.0185 31.402 34.0114 30.2833 32.8926L28.7184 31.3277L28.7198 31.3263ZM16.4516 14.9904L26.2061 5.23278C26.6678 4.77109 26.6862 4.08707 26.243 3.64096L24.6568 2.04349C24.2008 1.58464 23.4786 1.51666 22.9872 2.00808L13.1533 11.845C12.6902 12.3081 12.7398 13.0021 13.1703 13.4326L14.7593 15.0216C15.2294 15.4932 15.9248 15.5172 16.4516 14.9918V14.9904ZM37.3641 18.6485L26.2557 7.54119L18.7146 15.0867L29.8329 26.194L37.3641 18.6485ZM33.1425 31.6804L42.9466 21.8647C43.3771 21.4327 43.3417 20.7445 42.9466 20.3493L41.2458 18.6513C40.8153 18.2222 40.1143 18.2576 39.671 18.7009L29.8867 28.4826C29.4081 28.9613 29.4024 29.6623 29.8683 30.1282L31.4587 31.7186C31.9204 32.1803 32.6228 32.2015 33.1439 31.6804H33.1425ZM5.2228 42.663L24.5775 23.3106L21.6078 20.321L2.10724 39.8264C1.41757 40.7738 1.53652 41.9903 2.37773 42.7183C3.15379 43.391 4.34761 43.4349 5.22422 42.663H5.2228Z" fill="#009197" />
        <path d="M52.18 52.9957L24.1881 52.9999C23.6712 52.9999 23.3058 52.643 23.3073 52.1559L23.3242 47.0618C23.3299 45.2731 24.7362 43.8951 26.4497 43.5694C26.4993 42.8967 26.4667 42.3118 26.4696 41.6519C26.4795 39.5757 28.0953 37.8749 30.2153 37.8734L45.9971 37.8635C48.1553 37.8635 49.8221 39.5162 49.8335 41.659C49.8363 42.3047 49.8065 42.9024 49.8505 43.5708C51.6773 43.9036 53 45.4091 52.9986 47.2742L52.9958 52.1573C52.9958 52.5538 52.7281 52.9971 52.18 52.9971V52.9957ZM48.1595 43.5113L48.1765 41.6575C48.1666 40.4254 47.2433 39.5205 45.9942 39.5205H30.3272C29.0739 39.5205 28.1321 40.4127 28.1293 41.6604C28.1293 42.2778 28.1038 42.884 28.1548 43.517L48.1595 43.5113ZM51.3346 51.3387L51.3488 47.2714C51.3162 46.103 50.4651 45.2136 49.2698 45.1697H27.0473C25.8549 45.2051 24.9642 46.1016 24.9684 47.2742L24.9826 51.3444L51.336 51.3387H51.3346Z" fill="#009197" />
      </g>
      <defs>
        <clipPath id="clip0_431_119">
          <rect width="53" height="53" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SquareGrid = ({
}) => {
  return (
    <svg width="747" height="597" viewBox="0 0 747 597" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M747 596.976H0V-18.0902H747V596.976ZM0.760833 596.35H746.232V-17.4638H0.760833V596.344V596.35ZM746.62 557.948H0.380417V558.574H746.62V557.948ZM746.62 519.54H0.380417V520.167H746.62V519.54ZM746.62 481.139H0.380417V481.765H746.62V481.139ZM746.62 442.737H0.380417V443.363H746.62V442.737ZM746.62 404.335H0.380417V404.962H746.62V404.335ZM746.62 365.933H0.380417V366.56H746.62V365.933ZM746.62 327.532H0.380417V328.158H746.62V327.532ZM746.62 289.13H0.380417V289.756H746.62V289.13ZM746.62 250.728H0.380417V251.354H746.62V250.728ZM746.62 212.326H0.380417V212.953H746.62V212.326ZM746.62 173.919H0.380417V174.545H746.62V173.919ZM746.62 135.517H0.380417V136.143H746.62V135.517ZM746.62 97.1151H0.380417V97.7416H746.62V97.1151ZM746.62 58.7133H0.380417V59.3398H746.62V58.7133ZM746.62 20.3116H0.380417V20.938H746.62V20.3116ZM700.361 -17.777H699.6V596.663H700.361V-17.777ZM653.722 -17.777H652.961V596.663H653.722V-17.777ZM607.083 -17.777H606.322V596.663H607.083V-17.777ZM560.444 -17.777H559.683V596.663H560.444V-17.777ZM513.805 -17.777H513.044V596.663H513.805V-17.777ZM467.159 -17.777H466.398V596.663H467.159V-17.777ZM420.519 -17.777H419.759V596.663H420.519V-17.777ZM373.88 -17.777H373.12V596.663H373.88V-17.777ZM327.241 -17.777H326.48V596.663H327.241V-17.777ZM280.602 -17.777H279.841V596.663H280.602V-17.777ZM233.963 -17.777H233.202V596.663H233.963V-17.777ZM187.324 -17.777H186.563V596.663H187.324V-17.777ZM140.685 -17.777H139.924V596.663H140.685V-17.777ZM94.0459 -17.777H93.2851V596.663H94.0459V-17.777ZM47.4068 -17.777H46.646V596.663H47.4068V-17.777Z" fill="url(#paint0_radial_421_207)" />
      <defs>
        <radialGradient id="paint0_radial_421_207" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(373.5 289.443) scale(199.414 164.194)">
          <stop stop-color="white" stop-opacity="0.4" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const MzadcomLogoW = ({
}) => {
  return (
    <svg width="70" height="55" viewBox="0 0 98 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_mzadcom_w)">
        <path d="M45.1071 26.0032C42.6564 26.0032 40.3079 24.9724 38.6486 23.1684L41.814 20.1531C42.682 21.0809 43.8562 21.5963 45.1071 21.5963C47.6088 21.5963 49.6254 19.5604 49.6254 17.0348C49.6254 14.5092 47.6088 12.4733 45.1071 12.4733C43.8562 12.4733 42.682 12.9887 41.814 13.9165L38.6486 10.9012C40.3079 9.09726 42.682 8.06641 45.1071 8.06641C50.0083 8.06641 53.9651 12.0867 53.9651 17.009C53.9651 21.9571 49.9828 25.9517 45.1071 25.9517V26.0032Z" fill="white" />
        <path d="M27.8505 8.14374L32.4199 1.88132H27.0081L20.2688 11.1332L23.6129 13.9423C24.4809 13.0145 25.6551 12.4991 26.906 12.4991C29.3821 12.4991 31.4243 14.535 31.4243 17.0606C31.4243 19.5862 29.3821 21.6221 26.906 21.6221H16.4908C17.2821 20.282 17.7161 18.7357 17.7161 17.0606C17.7161 12.1125 13.7338 8.09219 8.83252 8.09219C3.95677 8.09219 -0.0255127 12.1125 -0.0255127 17.0606V54.2228H4.33969V24.7662C5.53948 25.4878 6.89244 25.9259 8.37303 26.0032C8.52619 26.0032 8.70489 26.0032 8.85805 26.0032H26.906C31.7817 26.0032 35.7895 21.9829 35.7895 17.0606C35.7895 12.4475 32.3178 8.63339 27.8505 8.14374ZM8.85805 21.5963C6.40741 21.5963 4.41627 19.6119 4.33969 17.1637V17.0606C4.33969 14.535 6.35636 12.4991 8.85805 12.4991C11.3597 12.4991 13.3764 14.535 13.3764 17.0606C13.3764 19.5862 11.3597 21.6221 8.85805 21.6221V21.5963Z" fill="white" />
        <path d="M89.142 8.09216C84.2662 8.09216 80.2839 12.1125 80.2839 17.0606C80.2839 18.7099 80.7434 20.282 81.5093 21.6221H71.1962V8.11793H66.882V23.1168C66.882 25.5393 64.9164 27.5237 62.5168 27.5237V31.9306C66.3204 31.9306 69.5624 29.4565 70.7367 26.029H89.1165C94.0177 26.029 98 22.0086 98 17.0863C98 12.164 94.0177 8.11793 89.1165 8.11793L89.142 8.09216ZM89.142 21.6221C86.6658 21.6221 84.6236 19.5861 84.6236 17.0606C84.6236 14.535 86.6403 12.499 89.142 12.499C91.6437 12.499 93.6603 14.535 93.6603 17.0606C93.6603 19.5861 91.6437 21.6221 89.142 21.6221Z" fill="white" />
        <path d="M61.1894 1.88132H56.8242V26.0032H61.1894V1.88132Z" fill="white" />
        <path d="M68.9497 5.2058C70.3737 5.2058 71.528 4.04044 71.528 2.6029C71.528 1.16536 70.3737 0 68.9497 0C67.5258 0 66.3715 1.16536 66.3715 2.6029C66.3715 4.04044 67.5258 5.2058 68.9497 5.2058Z" fill="white" />
        <path d="M22.3876 31.7502V44.9966H19.6562V37.9095L15.9292 42.9092L12.483 38.2188V44.9966H9.75153V31.7502H11.079L15.9547 38.3219L20.8815 31.7502H22.3876Z" fill="white" />
        <path d="M34.4366 44.9966H24.7361L29.5608 37.858H25.2978V35.1005H34.7174L29.9438 42.1618H34.4366V44.9966Z" fill="white" />
        <path d="M44.1881 35.1005V35.5901C43.5499 35.2809 42.8351 35.1005 42.0693 35.1005C39.3889 35.1005 37.1935 37.291 37.1935 40.0228C37.1935 42.7545 39.3889 44.9451 42.0693 44.9451C42.8351 44.9451 43.5499 44.7647 44.1881 44.4554V45.0224H46.9706V35.1262H44.1881V35.1005ZM42.0948 42.136C40.9461 42.136 40.0016 41.1825 40.0016 40.0228C40.0016 38.8631 40.9461 37.9095 42.0948 37.9095C43.2436 37.9095 44.1881 38.8631 44.1881 40.0228C44.1881 41.1825 43.2436 42.136 42.0948 42.136Z" fill="white" />
        <path d="M78.5226 35.1262C75.8166 35.1262 73.6213 37.3425 73.6213 40.0743C73.6213 42.8061 75.8166 45.0224 78.5226 45.0224C81.2285 45.0224 83.4238 42.8061 83.4238 40.0743C83.4238 37.3425 81.2285 35.1262 78.5226 35.1262ZM78.5226 42.1875C77.3483 42.1875 76.4038 41.234 76.4038 40.0485C76.4038 38.8631 77.3483 37.9353 78.5226 37.9353C79.6968 37.9353 80.6158 38.8888 80.6158 40.0485C80.6158 41.2082 79.6713 42.1875 78.5226 42.1875Z" fill="white" />
        <path d="M67.367 44.9966C64.6611 44.9966 62.4658 42.7803 62.4658 40.0485C62.4658 37.3168 64.6611 35.1005 67.367 35.1005C68.6434 35.1005 69.8432 35.5901 70.7622 36.4663L68.8221 38.5023C68.4392 38.1157 67.9031 37.9095 67.367 37.9095C66.2183 37.9095 65.2738 38.8631 65.2738 40.0228C65.2738 41.1825 66.2183 42.136 67.367 42.136C67.9286 42.136 68.4392 41.9299 68.8221 41.5433L70.7622 43.5792C69.8432 44.4812 68.6434 44.9709 67.367 44.9709V44.9966Z" fill="white" />
        <path d="M56.8242 31.7502V35.6159C56.186 35.3066 55.4712 35.1263 54.7054 35.1263C51.9995 35.1263 49.8041 37.3426 49.8041 40.0743C49.8041 42.8061 51.9995 45.0224 54.7054 45.0224C57.4113 45.0224 59.6067 42.8061 59.6067 40.0743V31.776H56.8242V31.7502ZM54.7309 42.1876C53.5822 42.1876 52.6121 41.234 52.6121 40.0486C52.6121 38.8631 53.5567 37.9353 54.7309 37.9353C55.9052 37.9353 56.8497 38.8889 56.8497 40.0486C56.8497 41.2083 55.9052 42.1876 54.7309 42.1876Z" fill="white" />
        <path d="M98 38.7857V44.9966H95.2175V38.7857C95.2175 38.3219 94.8346 37.9353 94.3751 37.9353C93.9156 37.9353 93.5327 38.3219 93.5327 38.7857V44.9966H90.7502V38.7857C90.7502 38.3219 90.3673 37.9353 89.9078 37.9353C89.4483 37.9353 89.0654 38.3219 89.0654 38.7857V44.9966H86.2829V38.7857C86.2829 36.7756 87.9167 35.1262 89.9078 35.1262C90.7502 35.1262 91.5416 35.4097 92.1542 35.8994C92.7669 35.4097 93.5582 35.1262 94.4006 35.1262C96.3918 35.1262 98.0255 36.7756 98.0255 38.7857H98Z" fill="white" />
        <path d="M12.5595 54.197C14.1103 54.197 15.3675 52.9278 15.3675 51.3621C15.3675 49.7965 14.1103 48.5273 12.5595 48.5273C11.0087 48.5273 9.7515 49.7965 9.7515 51.3621C9.7515 52.9278 11.0087 54.197 12.5595 54.197Z" fill="white" />
        <path d="M21.0346 54.197C22.5855 54.197 23.8427 52.9278 23.8427 51.3621C23.8427 49.7965 22.5855 48.5273 21.0346 48.5273C19.4838 48.5273 18.2266 49.7965 18.2266 51.3621C18.2266 52.9278 19.4838 54.197 21.0346 54.197Z" fill="white" />
        <path d="M29.5098 54.197C31.0606 54.197 32.3178 52.9278 32.3178 51.3621C32.3178 49.7965 31.0606 48.5273 29.5098 48.5273C27.9589 48.5273 26.7018 49.7965 26.7018 51.3621C26.7018 52.9278 27.9589 54.197 29.5098 54.197Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_mzadcom_w">
          <rect width="98" height="54.197" fill="white" />
        </clipPath>
      </defs>
    </svg>


  );
};

export const LangSwitch = ({ width = 32, height = 32 }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M383 5106 c-181 -44 -334 -202 -372 -384 -15 -74 -15 -2330 0 -2404
39 -187 200 -348 387 -387 36 -7 290 -11 787 -11 l735 0 0 -735 c0 -497 4
-751 11 -787 39 -187 200 -348 387 -387 74 -15 2330 -15 2404 0 187 39 348
200 387 387 7 33 11 191 11 420 0 408 1 400 -66 428 -29 12 -39 12 -66 1 -65
-27 -63 -13 -68 -436 l-5 -386 -28 -57 c-32 -64 -80 -111 -146 -142 -46 -21
-47 -21 -1221 -21 l-1175 0 -57 28 c-64 32 -111 80 -142 146 -21 46 -21 47
-21 1221 l0 1175 28 57 c32 64 80 111 146 142 46 21 47 21 1221 21 1174 0
1175 0 1221 -21 66 -31 114 -78 146 -142 l28 -57 5 -383 5 -384 28 -24 c38
-33 96 -33 134 0 l28 24 3 364 c2 243 -1 383 -8 423 -36 190 -199 354 -388
394 -36 7 -290 11 -787 11 l-735 0 0 735 c0 497 -4 751 -11 787 -39 187 -200
348 -387 387 -80 17 -2349 14 -2419 -3z m2449 -219 c64 -32 111 -80 142 -146
21 -45 21 -58 24 -793 l2 -747 -342 -3 c-326 -3 -346 -4 -402 -25 -33 -13 -77
-34 -97 -48 -21 -13 -40 -21 -42 -17 -3 4 -89 228 -192 497 -103 270 -195 509
-205 532 -21 48 -69 83 -113 83 -42 0 -96 -29 -112 -60 -28 -55 -475 -1222
-475 -1241 0 -32 26 -74 55 -87 34 -16 60 -15 94 2 29 15 40 36 95 181 l34 90
303 0 302 0 34 -89 33 -89 -22 -61 c-22 -58 -23 -77 -26 -404 l-3 -342 -747 2
c-735 3 -748 3 -793 24 -66 31 -114 78 -146 142 l-28 57 -3 1145 c-2 807 0
1160 8 1196 22 101 93 181 193 216 49 16 119 17 1212 15 l1160 -2 57 -28z
m-1118 -1290 c58 -152 106 -279 106 -282 0 -3 -99 -5 -221 -5 -173 0 -220 3
-216 13 2 6 46 120 97 252 110 287 119 309 124 304 2 -2 52 -129 110 -282z"
        />
        <path
          d="M3423 2281 c-168 -58 -247 -242 -174 -406 l20 -44 -34 -21 c-89 -55
-180 -193 -204 -308 -64 -306 177 -602 489 -602 230 0 442 172 489 398 22 105
9 162 -40 188 -35 18 -63 18 -98 -1 -32 -16 -47 -48 -55 -118 -13 -105 -71
-189 -164 -234 -81 -40 -183 -40 -264 0 -107 53 -162 143 -163 267 0 62 5 85
28 132 45 93 129 151 234 164 26 3 61 10 76 16 29 11 57 53 57 87 0 52 -48
101 -100 101 -52 0 -100 49 -100 101 0 32 26 74 55 87 14 7 57 12 95 12 81 0
116 13 136 51 27 52 8 115 -41 137 -40 18 -181 14 -242 -7z"
        />
        <path
          d="M4983 1695 c-99 -43 -71 -185 36 -185 96 0 138 124 59 173 -37 24
-61 27 -95 12z"
        />
      </g>
    </svg>
  );
};

export const Logo = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="3601.000000pt"
      height="2879.000000pt"
      viewBox="0 0 3601.000000 2879.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,2879.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M5915 21346 c-27 -12 -67 -41 -87 -64 -71 -79 -68 -22 -68 -1225 l0
-1079 70 66 c176 165 386 308 635 431 380 188 683 265 1125 285 119 6 213 15
242 24 176 55 311 185 370 353 23 68 23 70 23 558 0 486 0 490 -22 531 -29 54
-101 117 -151 132 -29 9 -307 12 -1063 12 l-1024 0 -50 -24z m1209 -382 c49
-25 93 -78 102 -122 l7 -32 -77 0 c-59 0 -76 3 -76 14 0 26 -50 56 -94 56 -54
0 -86 -22 -86 -60 0 -37 24 -53 109 -75 182 -46 241 -98 241 -210 0 -129 -115
-205 -292 -193 -117 9 -206 75 -224 166 l-6 32 74 0 c73 0 74 0 85 -30 32 -85
213 -76 213 10 0 44 -32 65 -141 95 -151 42 -209 93 -209 186 0 83 54 153 138
180 51 16 193 6 236 -17z m-832 -116 l3 -132 115 132 115 132 88 0 88 0 -118
-125 c-65 -69 -119 -130 -121 -135 -2 -5 50 -84 115 -177 66 -92 122 -174 127
-180 5 -10 -13 -13 -81 -13 l-88 1 -78 117 c-117 175 -102 161 -137 127 -30
-28 -30 -30 -30 -137 l0 -108 -75 0 -75 0 0 315 0 315 75 0 74 0 3 -132z
m1483 -90 c43 -123 93 -265 111 -315 l33 -93 -79 0 -79 0 -22 70 -23 71 -115
-3 -114 -3 -22 -65 -22 -65 -71 -3 c-40 -2 -72 -1 -72 0 0 3 196 592 205 616
3 8 32 12 98 12 l94 0 78 -222z"
        />
        <path
          d="M7561 20747 c-18 -61 -35 -118 -38 -124 -3 -10 16 -13 77 -13 67 0
81 3 77 14 -3 8 -20 61 -38 118 -18 57 -35 106 -39 110 -3 5 -21 -43 -39 -105z"
        />
        <path
          d="M22925 20813 c-205 -32 -379 -148 -480 -319 -41 -71 -76 -190 -82
-283 -18 -301 190 -583 487 -657 79 -20 215 -22 290 -4 240 56 433 249 486
488 21 95 15 240 -15 332 -79 249 -311 429 -571 443 -47 3 -98 3 -115 0z"
        />
        <path
          d="M12518 20328 c-14 -18 -382 -519 -818 -1113 -436 -594 -803 -1094
-816 -1110 l-23 -31 401 -334 c221 -184 407 -339 415 -343 9 -6 33 10 76 48
338 307 831 378 1244 180 121 -57 199 -111 295 -203 241 -230 359 -528 345
-866 -19 -455 -308 -850 -737 -1007 -185 -67 -74 -63 -1602 -66 l-1386 -4 58
113 c278 536 326 1144 134 1717 -234 704 -822 1252 -1539 1436 -208 53 -333
69 -555 69 -222 0 -347 -16 -555 -69 -569 -146 -1058 -520 -1358 -1036 -137
-236 -220 -472 -274 -777 -16 -90 -18 -414 -20 -4799 l-3 -4703 540 0 540 0 0
3635 c0 1999 2 3635 5 3635 3 0 73 -33 157 -74 236 -116 438 -176 701 -211
104 -13 412 -15 2508 -15 1607 0 2422 3 2487 11 146 15 326 54 466 100 147 48
384 162 511 246 771 510 1146 1413 958 2308 -108 516 -412 990 -839 1311 -297
223 -695 386 -1024 421 -33 3 -60 10 -60 15 0 7 490 678 1092 1496 l39 52
-669 0 -670 0 -24 -32z m-4381 -2599 c129 -14 248 -49 370 -109 683 -335 846
-1234 323 -1784 -338 -356 -854 -456 -1297 -251 -237 110 -458 337 -559 576
-235 558 1 1197 540 1459 205 100 401 134 623 109z"
        />
        <path
          d="M19980 17375 l0 -2975 540 0 540 0 0 2975 0 2975 -540 0 -540 0 0
-2975z"
        />
        <path
          d="M16884 18810 c-507 -42 -991 -258 -1346 -599 l-93 -90 35 -34 c42
-41 684 -642 722 -676 l27 -24 73 63 c194 168 406 258 653 279 554 47 1046
-303 1193 -847 23 -88 26 -114 26 -277 0 -163 -3 -189 -27 -278 -28 -105 -104
-275 -158 -353 -160 -232 -389 -392 -672 -467 -70 -18 -108 -21 -267 -21 -168
0 -194 2 -283 27 -177 48 -352 144 -474 260 l-61 59 -344 -323 c-188 -177
-365 -344 -393 -370 l-50 -49 55 -56 c73 -74 234 -204 342 -275 112 -74 316
-177 442 -223 578 -216 1240 -175 1786 111 213 111 390 244 566 424 348 358
559 806 614 1307 17 156 8 442 -19 597 -167 951 -921 1683 -1871 1819 -137 19
-349 27 -476 16z"
        />
        <path
          d="M22490 16955 c0 -1258 -3 -1897 -11 -1962 -19 -172 -86 -356 -180
-494 -61 -90 -188 -219 -275 -279 -157 -109 -355 -181 -538 -196 l-86 -7 0
-538 0 -539 54 0 c256 0 618 88 877 213 370 179 693 468 906 810 63 102 174
329 194 395 l12 42 2378 0 c2631 0 2484 -3 2754 65 782 197 1400 811 1600
1590 50 195 68 341 68 550 0 117 -6 222 -17 300 -142 985 -907 1750 -1891
1891 -159 23 -450 23 -600 0 -748 -114 -1359 -560 -1685 -1231 -152 -311 -220
-611 -220 -963 1 -364 81 -696 246 -1011 30 -58 54 -106 54 -108 0 -2 -578 -3
-1285 -3 l-1285 0 0 1670 0 1670 -535 0 -535 0 0 -1865z m5757 760 c220 -42
409 -141 576 -304 224 -218 340 -492 339 -806 0 -251 -73 -474 -219 -670 -180
-241 -449 -403 -742 -445 -115 -17 -332 -7 -435 19 -355 93 -643 343 -775 673
-100 250 -107 546 -19 798 37 105 56 143 123 246 161 249 431 430 725 489 92
19 330 18 427 0z"
        />
        <path
          d="M8230 11335 l0 -1635 340 0 340 0 2 836 3 836 425 -571 c234 -313
428 -569 432 -568 4 1 210 270 458 597 248 327 457 602 465 610 13 12 15 -95
15 -863 l0 -877 335 0 335 0 0 1635 0 1635 -187 0 -188 -1 -610 -807 c-336
-444 -614 -807 -620 -806 -5 0 -280 363 -610 805 l-601 804 -167 3 -167 2 0
-1635z"
        />
        <path
          d="M19980 12495 c0 -261 -1 -475 -2 -475 -2 0 -36 14 -77 30 -446 182
-966 75 -1311 -270 -526 -527 -463 -1384 136 -1838 85 -65 284 -164 384 -192
308 -85 596 -59 875 80 182 91 323 206 443 366 66 87 165 285 192 384 49 179
50 194 50 1328 l0 1062 -345 0 -345 0 0 -475z m-425 -1060 c218 -46 383 -219
417 -437 44 -285 -159 -556 -446 -599 -347 -52 -651 253 -598 599 34 215 199
390 412 436 85 19 130 19 215 1z"
        />
        <path
          d="M12110 11805 l0 -335 530 0 c292 0 530 -4 530 -8 0 -5 -270 -403
-599 -885 l-599 -877 1209 0 1209 0 0 350 0 350 -560 0 c-308 0 -560 2 -560 4
0 3 262 389 583 858 321 469 587 859 591 866 6 9 -230 12 -1163 12 l-1171 0 0
-335z"
        />
        <path
          d="M16065 12120 c-242 -50 -446 -160 -621 -334 -180 -181 -293 -397
-340 -651 -24 -134 -15 -366 19 -498 117 -444 450 -772 897 -885 95 -24 122
-26 285 -26 160 1 190 3 276 26 52 14 129 39 170 56 l74 29 3 -68 3 -69 344 0
345 0 0 1220 0 1220 -345 0 -345 0 0 -55 c0 -30 -3 -55 -6 -55 -3 0 -48 15
-98 34 -202 76 -458 98 -661 56z m400 -691 c206 -63 355 -266 357 -484 1 -104
-15 -172 -61 -260 -64 -123 -181 -218 -320 -259 -67 -20 -207 -21 -276 -2
-267 71 -436 341 -381 606 66 316 371 495 681 399z"
        />
        <path
          d="M22455 12130 c-416 -59 -756 -303 -942 -675 -141 -280 -163 -627 -59
-933 116 -340 405 -631 746 -750 146 -51 239 -66 405 -66 258 0 454 58 670
199 44 28 101 72 127 96 l47 44 -237 244 -238 243 -69 -46 c-213 -143 -490
-118 -669 59 -210 207 -210 543 0 750 179 177 456 202 669 59 l69 -47 106 111
c58 61 163 173 235 248 l130 136 -45 41 c-137 122 -338 222 -540 268 -97 22
-314 32 -405 19z"
        />
        <path
          d="M25235 12129 c-154 -21 -325 -79 -455 -155 -213 -124 -396 -322 -495
-536 -147 -319 -153 -680 -17 -996 250 -579 899 -875 1493 -681 97 31 217 90
305 149 109 73 268 235 339 344 313 482 254 1098 -146 1511 -174 180 -391 299
-636 350 -96 20 -293 27 -388 14z m260 -694 c105 -22 189 -68 264 -144 105
-105 151 -218 151 -371 0 -153 -46 -266 -151 -371 -162 -163 -398 -202 -604
-100 -264 131 -369 442 -238 710 42 87 142 185 237 231 118 58 217 71 341 45z"
        />
        <path
          d="M28095 12130 c-197 -31 -400 -139 -532 -283 -100 -110 -175 -249
-215 -399 -22 -82 -22 -94 -25 -915 l-4 -833 345 0 345 0 3 793 c3 870 0 827
64 890 46 46 83 61 149 61 98 0 173 -53 204 -143 8 -24 11 -258 11 -817 l0
-784 345 0 345 0 0 784 c0 559 3 793 11 817 26 77 91 131 176 145 100 16 210
-62 232 -164 8 -37 11 -289 11 -817 l0 -765 345 0 345 0 0 778 c0 479 -4 809
-10 861 -12 93 -50 221 -88 296 -119 237 -347 417 -609 482 -103 25 -314 23
-418 -6 -88 -23 -221 -84 -289 -131 -25 -16 -47 -30 -51 -30 -4 0 -26 14 -51
30 -69 48 -202 108 -289 130 -92 24 -261 33 -350 20z"
        />
      </g>
    </svg>
  );
};
